export default "__VITE_ASSET__CosxzsMn__"